"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var action_row_styles_1 = require("../action-row/action-row.styles");

var Link_1 = __importDefault(require("@material-ui/icons/Link"));

var select_url_variable_container_1 = __importDefault(require("../select-url-variable/select-url-variable.container"));

var custom_modal_component_1 = __importDefault(require("../../common-components/custom-modal/custom-modal.component"));

var select_url_variable_modal_styles_1 = require("./select-url-variable-modal.styles");

var SelectUrlVariableModal = function SelectUrlVariableModal(_ref) {
  var isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      onUrlVariableSelect = _ref.onUrlVariableSelect;
  return react_1.default.createElement(custom_modal_component_1.default, {
    isOpen: isOpen,
    handleClose: handleClose
  }, react_1.default.createElement(select_url_variable_modal_styles_1.SelectUrlVariableModalContent, null, react_1.default.createElement(select_url_variable_modal_styles_1.SelectUrlVariableModalTitle, null, react_1.default.createElement(action_row_styles_1.ActionIconWrapperDiv, null, react_1.default.createElement(Link_1.default, null)), "\u9077\u79FB\u5148 URL \u3092\u9078\u629E"), react_1.default.createElement(select_url_variable_container_1.default, {
    handleSelectVariable: function handleSelectVariable(variable) {
      onUrlVariableSelect(variable);
      handleClose();
    }
  })));
};

exports.default = SelectUrlVariableModal;